import { useEffect, useRef, useState, useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, myFaceAtom, isFaceDetectReadyAtom, tapCameraAtom } from '../../State';
import { ReactComponent as FaceScanSVG } from '../Images/avatar/faceScanWrap.svg';
import { ReactComponent as FaceScanLineSVG } from '../Images/avatar/faceScanLine.svg';
import { useTranslation } from 'react-i18next';
import KUTE from 'kute.js';
export default function LoadingFace({}) {
  const isFaceDetectReady = useRecoilValue(isFaceDetectReadyAtom);
  const [tapCameraState, setTapCameraState] = useRecoilState(tapCameraAtom);
  const [webcamState, setWebcamState] = useRecoilState(webcamAtom);
  const [showLoading, setShowLoading] = useState(true);
  const domExist = useRef(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (isFaceDetectReady || webcamState == false) {
      if (showLoading == false) {
        return;
      }

      let kute = KUTE.to(
        '#loadingFace',
        { opacity: '0' },
        {
          duration: 100,
          onComplete: () => {
            //アニメーション終了あと
            setShowLoading(false);
            domExist.current = false;
          },
        },
      );
      kute.start();
    } else {
      setShowLoading(true);
    }
  }, [isFaceDetectReady, webcamState]);

  useEffect(() => {
    if (showLoading) {
      let kute = KUTE.to(
        '#loadingFace',
        { opacity: '1' },
        {
          duration: 0,
          onComplete: () => {
            //アニメーション終了あと
            //  setShowLoading(false);
            //domExist.current = false;
          },
        },
      );
      kute.start();
    }
  }, [showLoading]);

  //7秒遅れて表示させる
  useEffect(() => {
    setTimeout(() => {
      if (domExist.current) {
        let kute = KUTE.to(
          '#loadingDelayWrap',
          { opacity: '1' },
          {
            duration: 100,
          },
        );
        kute.start();
      }
    }, 7000);
  }, []);

  const tapCameraButton = () => {
    if (tapCameraState) {
      setTapCameraState(false);
    } else {
      setTapCameraState(true);
    }
  };

  const tapOffButton = () => {
    //ウェブカメラをストップ
    setWebcamState(!webcamState);
    localStorage.setItem('mode', 'ai');
  };

  //レンダー処理
  return (
    <>
      {showLoading && (
        <div id="loadingFace">
          <div id="loadingFaceWrapWrap">
            <div id="loadingFaceWrap">
              <FaceScanSVG id="loadingFaceWaku" />
              <FaceScanLineSVG id="loadingFaceLine" />

              <div id="loadingFaceText">
                <div>{t('haircheck.Detecting Your Face...')}</div>
                <div id="loadingDelayWrap">
                  <button id="loadingSelectCamera" onClick={tapCameraButton}>
                    {t('haircheck.Select Camera')}
                  </button>
                  <div id="loadingOffCamera" onClick={tapOffButton}>
                    {t('haircheck.Turn off camera')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
